import { render } from "./AvaliableQuiz.vue?vue&type=template&id=155d4955&scoped=true"
import script from "./AvaliableQuiz.vue?vue&type=script&lang=js"
export * from "./AvaliableQuiz.vue?vue&type=script&lang=js"

import "./AvaliableQuiz.vue?vue&type=style&index=0&id=155d4955&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\projetos\\mestre\\mestre-do-valor-sn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-155d4955"]])

export default __exports__